import { useQuery } from '@tanstack/react-query';
import { adsService } from '../services/ads.service';
import type { CampaignFilters } from '../types/ads.types';

export function useCampaigns(filters?: CampaignFilters) {
  return useQuery({
    queryKey: ['campaigns', filters],
    queryFn: () => adsService.getCampaigns(filters),
  });
}
